<div class="inputWithOptions position-relative" (blur)="inFocus = false">
  <input class="form-control borderless" type="text" [(ngModel)]="inputValue" (focus)="focus()" (blur)="blurOut()" (keyup)="filter($event)" placeholder="{{ 'Standard.Search' | translate }}" autocomplete="'nothing'">
  <div class="suggestedStringList" *ngIf="inFocus && !!shownOptions && !!shownOptions.length" style="width:100%">
    <div *ngFor="let x of shownOptions; let i = index" style="width:100%" (hover)="isHovering = x.key" (click)="in = x.key; inputValue = x.value;inFocus = false; makeChange();" [ngClass]="isHovering == x.key || highlightIndex == i ? 'hoveredText' : ''">
      {{ x.value }}
    </div>
  </div>
</div>
